import { IconChevronDown } from "app/components/Icon/Icon";

export const BetBuilderCollapsibleHeader: React.FC<{
  multiplierName: string | undefined;
  collapsibleOpen: boolean;
}> = ({ multiplierName, collapsibleOpen }) => (
  <div className="report__header">
    <div className="report__header__title__secondary">
      <div className="report__header__collapsible bet-builder-collapsible-header">
        <span>{multiplierName}</span>
        <span
          className={`report__header__collapsible__arrow ${
            collapsibleOpen ? "report__header__collapsible__arrow--up" : ""
          }`}
        >
          <IconChevronDown currentColor />
        </span>
      </div>
    </div>
  </div>
);
